import styled from "styled-components";
import {useEffect, useState} from "react";
import {SimulationSummary} from "../../api/types";
import {agent} from "../../api/agent";
import {useNavigate} from "react-router-dom";
import Loading from "../Loading";
import Status from "../Status";

const Container = styled.div`

    .content {
        display: grid;
        gap: 1rem;
        justify-content: center;
        margin: 1rem 0;
        grid-template-columns: 40%;
    }

    .simulation-item {
        background-color: var(--content-box-bg);
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        padding: 2rem;
        display: flex;
        flex-direction: column;
        gap: .35rem;
        cursor: pointer;
    }

    .simulation-item:hover {
        background-color: var(--content-box-hover);
    }

    .simulation-item h1 {
        margin: 0;
        font-family: monospace;
        font-size: 1.1rem;
    }

    .top-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: .75rem;
    }

    .top-row .actions {
        display: flex;
        align-items: center;
        gap: .75rem;
    }

    .meta {
        opacity: .7;
        font-size: .85rem;
    }

    .empty {
        text-align: center;
        margin-top: 3rem;
        opacity: .7;
    }

`;

const POLL_INTERVAL_MS = 3000;

export default function SimulationList() {
    const [simulations, setSimulations] = useState<SimulationSummary[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const navigate = useNavigate();

    useEffect(() => {
        let cancelled = false;

        const load = () => {
            agent.getSimulations().then(value => {
                if (cancelled) return;
                setSimulations([...value].sort((a, b) => b.lastActivity - a.lastActivity));
                setLoading(false);
            });
        };

        load();
        const interval = setInterval(load, POLL_INTERVAL_MS);
        return () => {
            cancelled = true;
            clearInterval(interval);
        };
    }, []);

    const abortSimulation = (id: string) => {
        agent.deleteSimulation(id).then(() => {
            setSimulations(current => current.filter(simulation => simulation.id !== id));
        });
    };

    return (<>
        <Loading open={loading}></Loading>
        <Container>
            <div className={'content'}>
                {simulations.map(simulation => (
                    <div className={'simulation-item'} key={simulation.id}
                         onClick={() => navigate('/simulations?id=' + encodeURIComponent(simulation.id))}>
                        <div className={'top-row'}>
                            <h1>{simulation.id.slice(0, 8)}</h1>
                            <div className={'actions'}>
                                <a onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    abortSimulation(simulation.id);
                                }}>Abort</a>
                                <div style={{position: 'relative'}}>
                                    <Status status={simulation.isRunning ? 'running' : 'waiting'}></Status>
                                </div>
                            </div>
                        </div>
                        <div>{simulation.repo ?? 'No repo set yet'}</div>
                        <div>{simulation.hasPipeline ? (simulation.blockCount + ' blocks') : 'No pipeline yet'}</div>
                        <div className={'meta'}>last
                            activity: {new Date(simulation.lastActivity).toLocaleString()}</div>
                    </div>
                ))}
                {!loading && simulations.length === 0 && (
                    <div className={'empty'}>No active simulations - these appear here once an AI (via MCP)
                        calls create_pipeline.</div>
                )}
            </div>
        </Container>
    </>);
}
